export default "﻿<h1>void</h1>"